import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class GrupoProdutoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let lote = model;

        if (isNull(lote.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(lote.idloteerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if(!validated) {
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true))
        }

        return validated;
    }

}